import { type UpdateResolver } from "@urql/exchange-graphcache";
import { gql } from "urql";

import {
  type ApproveMembershipRequestInput,
  type ApproveMembershipRequestPayload,
  type Maybe,
} from "@/gql/graphql";

type Args = { input: ApproveMembershipRequestInput };
type Result = Maybe<{
  approveMembershipRequest: Maybe<ApproveMembershipRequestPayload>;
}>;

const updater: UpdateResolver<Result, Args> = (result, args, cache) => {
  if (
    args.input.id &&
    result?.approveMembershipRequest?.member?.organizationId
  ) {
    cache.updateQuery(
      {
        query: gql`
          query APPROVE_MEMBERSHIP_UPDAATER($organizationId: String!) {
            organization(id: $organizationId) {
              id
              membershipRequests {
                nodes {
                  id
                }
              }
            }
          }
        `,
        variables: {
          organizationId:
            result?.approveMembershipRequest.member.organizationId,
        },
      },
      (data) => {
        data.organization.membershipRequests.nodes =
          data.organization.membershipRequests.nodes.filter(
            (x: { id: string }) => x.id !== args.input.id,
          );
        return data;
      },
    );
  }
};

export const approveMembershipRequest = updater as unknown as UpdateResolver;
